<template>
  <v-window-item value="personal">
    <v-card-text>
      <v-card class="bg-white" variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-account</v-icon>
          Personal Information
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="father_name.value.value"
                  label="Father's Name"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :error-messages="father_name.errorMessage.value"
                  clearable
                />
                <v-text-field
                  v-model="mother_name.value.value"
                  label="Mother's Name"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :error-messages="mother_name.errorMessage.value"
                  clearable
                />
                <v-text-field
                  v-model="height.value.value"
                  label="Height"
                  type="number"
                  bg-color="grey-lighten-4"
                  variant="outlined"
                  density="compact"
                  :error-messages="height.errorMessage.value"
                />
                <v-text-field
                  v-model="weight.value.value"
                  label="Weight"
                  type="number"
                  bg-color="grey-lighten-4"
                  variant="outlined"
                  density="compact"
                  :error-messages="weight.errorMessage.value"
                />
                <v-date-input
                    input-format="dd/mm/yyyy"
                    v-model="date_of_birth.value.value"
                    label="To Date"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    prepend-icon=""
                    prepend-inner-icon="mdi-calendar"
                    :error-messages="date_of_birth.errorMessage.value"
                />
                <v-text-field
                  v-model="emergency_contact_person.value.value"
                  label="Emergency Contact Person"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :error-messages="emergency_contact_person.errorMessage.value"
                  clearable
                />
                <v-text-field
                  v-model="emergency_contact_no.value.value"
                  label="Emergency Contact No"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :error-messages="emergency_contact_no.errorMessage.value"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="nid.value.value"
                  label="NID"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :error-messages="nid.errorMessage.value"
                  clearable
                />
                <v-autocomplete
                  v-model="blood_group_id.value.value"
                  label="Blood Group"
                  :items="getBloodGroupList"
                  item-title="name"
                  item-value="id"
                  bg-color="grey-lighten-4"
                  variant="outlined"
                  density="compact"
                  :loading="loading"
                  :error-messages="blood_group_id.errorMessage.value"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                <v-autocomplete
                  v-model="gender_id.value.value"
                  label="Gender"
                  :items="getGenderList"
                  item-title="name"
                  item-value="id"
                  bg-color="grey-lighten-4"
                  variant="outlined"
                  density="compact"
                  :loading="loading"
                  :error-messages="gender_id.errorMessage.value"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                <v-autocomplete
                  v-model="marital_status_id.value.value"
                  label="Marital Status"
                  :items="getMaritalStatusList"
                  item-title="name"
                  item-value="id"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :loading="loading"
                  :error-messages="marital_status_id.errorMessage.value"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                <v-autocomplete
                  v-model="religion_id.value.value"
                  label="Religion"
                  :items="getReligionList"
                  item-title="name"
                  item-value="id"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :loading="loading"
                  :error-messages="religion_id.errorMessage.value"
                  clearable
                
                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                <v-text-field
                  v-model="passport_no.value.value"
                  label="Passport No"
                  bg-color="grey-lighten-4"
                  variant="outlined"
                  density="compact"
                  :error-messages="passport_no.errorMessage.value"
                  clearable
                />
              </v-col>
            </v-row>

            <v-card-actions class="px-0">
              <v-spacer />
              <v-btn
                  color="primary"
                  type="submit"
                  variant="flat"
                  :loading="submitting"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script>
import { useStore } from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { fileServerUrl } from '@/store/api';
import formattedDate from '@/plugins/dateFormatter';

export default {
  props: {
    userPersonalInfoData: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    loading: false,
    submitting: false,
  }),
  computed: {
    getBloodGroupList() {
      return this.$store.getters.getHrmBloodGroupList || [];
    },
    getGenderList() {
      return this.$store.getters.getHrmGenderList || [];
    },
    getMaritalStatusList() {
      return this.$store.getters.getHrmMaritalStatusList || [];
    },
    getReligionList() {
      return this.$store.getters.getHrmReligionList || [];
    }
  },
  created() {},
  methods: {

  },
  watch: {
    userPersonalInfoData: {
      handler(data) {
        console.log(data);
        const employee = data?.data || data || {};
        this.user_id.value.value = employee?.user?.id;
        this.employee_id.value.value = employee?.id || '';
        this.name.value.value = employee.name || '',
        this.branch_id.value.value = employee?.branch_id || '';
        this.father_name.value.value = employee.father_name || '';
        this.mother_name.value.value = employee.mother_name || '';
        this.height.value.value = employee.height ?? 0;
        this.weight.value.value = employee.weight ?? 0;
        this.section_id.value.value = employee.section_id || '';
        this.joining_date.value.value = employee.joining_date || '';
        this.phone_residence.value.value= employee.phone_residence || '';
        this.phone_office.value.value= employee.phone_office || '';
        this.date_of_birth.value.value = employee.date_of_birth || '';
        this.emergency_contact_person.value.value = employee.emergency_contact_person || '';
        this.emergency_contact_no.value.value = employee.emergency_contact_no || '';
        this.nid.value.value = employee.nid || '';
        this.blood_group_id.value.value = employee.blood_group_id || '';
        this.gender_id.value.value = employee.gender_id || '';
        this.marital_status_id.value.value = employee.marital_status_id || '';
        this.religion_id.value.value = employee.religion_id || '';
        this.passport_no.value.value = employee.passport_no || '';

        this.code.value.value = employee.code || ''
        this.employee_type_id.value.value = employee.employee_type_id || ''
        this.designation_id.value.value = employee.designation_id || ''
        this.department_id.value.value = employee.department_id || ''
        this.mobile.value.value = employee.mobile || ''
        this.email.value.value = employee.email || ''
        this.nationality.value.value = employee.nationality || ''

        this.status.value.value = employee.status ?? 1;
      },
      immediate: true,
      deep: true
    }
  },
  setup() {
    const store = useStore();
    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        father_name: yup.string().nullable().max(70).trim(),
        mother_name: yup.string().nullable().max(70).trim(),
        height: yup.number().nullable().max(300),
        weight: yup.number().nullable().max(500),
        date_of_birth: yup.date().nullable(),
        emergency_contact_person: yup.string().nullable().max(70).trim(),
        emergency_contact_no: yup.string().nullable().max(15).trim(),
        nid: yup.string().nullable().trim(),
        blood_group_id: yup.number().nullable(),
        gender_id: yup.number().nullable(),
        marital_status_id: yup.number().nullable(),
        religion_id: yup.number().nullable(),
        passport_no: yup.string().nullable().trim()
      })
    });

    const code = useField('code');
    const employee_type_id = useField('employee_type_id');
    const designation_id = useField('designation_id');
    const department_id = useField('department_id');
    const mobile = useField('mobile');
    const email = useField('email');
    const nationality = useField('nationality');

    const employee_id = useField('employee_id');
    const name = useField('name');
    const branch_id = useField('branch_id');
    const section_id = useField('section_id');
    const joining_date = useField('joining_date');
    const phone_residence = useField('phone_residence');
    const phone_office = useField('phone_office');
    const user_id = useField('user_id');
    const father_name = useField('father_name');
    const mother_name = useField('mother_name');
    const height = useField('height');
    const weight = useField('weight');
    const date_of_birth = useField('date_of_birth');
    const emergency_contact_person = useField('emergency_contact_person');
    const emergency_contact_no = useField('emergency_contact_no');
    const nid = useField('nid');
    const blood_group_id = useField('blood_group_id');
    const gender_id = useField('gender_id');
    const marital_status_id = useField('marital_status_id');
    const religion_id = useField('religion_id');
    const passport_no = useField('passport_no');
    const status = useField('status');
    const submitting = ref(false);

    const submit = handleSubmit((values) => {
      submitting.value = true;
      const formData = new FormData();
      Object.keys(values).forEach((key) => { formData.append(key, values[key] || '')});

      // Object.keys(formData).forEach((key) => {
      //   if(key=== 'date_of_birth'){
      //     formData.append(key, formattedDate(values[key]));
      //   }
      //   else {
      //     formData.append(key, values[key] ?? '');
      //   }
      // });

      store.dispatch('saveUpdateEmployeeSetup', formData)
        .then((response) => {
          toast.success(response.data.message, { timeout: 3000 });
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || 'Failed to update employee information');
        })
        .finally(() => {
          submitting.value = false;
        });
    });

    return {
      submit,
      code,
      employee_type_id,
      designation_id,
      department_id,
      mobile,
      email,
      nationality,
      user_id,
      employee_id,
      section_id,
      joining_date,
      phone_residence,
      phone_office,
      name,
      branch_id,
      father_name,
      mother_name,
      height,
      weight,
      date_of_birth,
      emergency_contact_person,
      emergency_contact_no,
      nid,
      blood_group_id,
      gender_id,
      marital_status_id,
      religion_id,
      passport_no,
      status,
      submitting
    };
  }
};
</script>
